import {ListParams} from '../../Components/List/hooks'
import {Filter, FilterOption, Tab} from '../../Components/Filters/types'

export type SearchPagination = {
  keyword: string
  currentPage: number
  totalPage: number
  commentCount: number
}

export type COMMENT_STATE = {
  readonly dateStart: Date | null
  readonly dateEnd: Date | null
  readonly websites: ReadonlyArray<string>
  readonly issues: ReadonlyArray<string>
} & ListParams

export const COMMENT_TABS: ReadonlyArray<Tab> = [
  {label: 'All Comments', value: 'all'},
  {label: 'Pending', value: 'pending'},
  {label: 'Approved', value: 'approved'},
  {label: 'Flagged', value: 'flagged'},
  {label: 'Spammed', value: 'spammed'},
  {label: 'Blocked', value: 'blocked'},
  {label: 'Deleted', value: 'deleted'},
]

export const INIT_SEARCH_STATE = {
  keyword: '',
  currentPage: 1,
  totalPage: 1,
  commentCount: 0,
}

export const INIT_STATE: COMMENT_STATE = {
  page: 1,
  tab: COMMENT_TABS[0].value,
  searchTerm: '',
  sort: null,
  websites: [],
  issues: [],
  dateStart: null,
  dateEnd: null,
}
export const COMMENT_FILTERS = (sites: ReadonlyArray<FilterOption<COMMENT_STATE>>): ReadonlyArray<Filter<COMMENT_STATE>> => [
  {
    displayName: 'Sort By',
    fieldName: 'sort',
    type: 'radio',
    options: [
      { name: 'New to old', value: { sortBy: 'createdAt', order: 'DESC' } },
      { name: 'Old to new', value: { sortBy: 'createdAt', order: 'ASC' } },
      { name: 'Username, A-Z', value: { sortBy: 'name', order: 'ASC' } },
      { name: 'Username, Z-A', value: { sortBy: 'name', order: 'DESC' } },
    ],
  },
  {
    displayName: 'Date',
    type: 'daterange',
    startFieldName: 'dateStart',
    endFieldName: 'dateEnd',
  },
  {
    displayName: 'Websites',
    fieldName: 'websites',
    type: 'checkbox',
    options: sites,
  },
]
